import type { Format } from "../types";

/**
 * Format a number for display.
 * - long:    locale-aware grouping (e.g., 12.345 in tr-TR)
 * - compact: short form (e.g., 12K)
 */
export function formatNumber(n: number, format: Format, locale: string): string {
  try {
    if (format === "compact") {
      return new Intl.NumberFormat(locale, {
        notation: "compact",
        maximumFractionDigits: 1,
      }).format(n);
    }
    return new Intl.NumberFormat(locale).format(n);
  } catch {
    return String(n);
  }
}
